module.exports = __webpack_public_path__ + "img/venue-back.8685cc12.jpg";